import { render, staticRenderFns } from "./MpHermitCrab.vue?vue&type=template&id=4082ab0b&scoped=true&"
import script from "./MpHermitCrab.vue?vue&type=script&lang=js&"
export * from "./MpHermitCrab.vue?vue&type=script&lang=js&"
import style0 from "./MpHermitCrab.vue?vue&type=style&index=0&id=4082ab0b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4082ab0b",
  null
  
)

export default component.exports